import Text, { TEXT_VARIANT } from '@pixum/text';
import { LogoLink } from './LogoLink';
import type { LinkListProps } from './types';
import type { CSSProperties } from 'react';
import clsx from 'clsx';

function List(props: LinkListProps) {
  const { align, direction, flow, links, navigationLink, type, variant, addHref = false } = props;
  const customProperties = {
    '--footer-links-list-item-align': align,
    '--footer-links-list-item-direction': direction,
    '--footer-links-list-item-flow': flow
  } as CSSProperties;

  return (
    <ul className="footer__links-list" style={customProperties}>
      {links.map((link, index) => (
        <li className="footer__links-list-item" key={`footer-logo-link-${type}-${index}`}>
          {variant === 'logo' && <LogoLink {...link} addHref={addHref} masked={!!navigationLink} />}
        </li>
      ))}
    </ul>
  );
}

export function LinkList(props: LinkListProps) {
  const { navigationLink, title, showCursor, type } = props;

  return (
    <section className="footer__links-list-section" id={type}>
      <Text className="footer__links-list-heading" variant={TEXT_VARIANT.HEADLINE}>
        {title}
      </Text>
      {navigationLink ? (
        <a
          className={clsx('footer__links-list-navigation-link', showCursor ? 'show-cursor' : '')}
          href={navigationLink}
          title={title}
        >
          <List {...props} addHref={false} />
        </a>
      ) : (
        <List {...props} />
      )}
    </section>
  );
}
